export const paymentMethodConstants = {
  //get
  GET_PAYMENT_METHOD_LIST_REQUEST: "GET_PAYMENT_METHOD_LIST_REQUEST",
  GET_PAYMENT_METHOD_LIST_SUCCESS: "GET_PAYMENT_METHOD_LIST_SUCCESS",
  GET_PAYMENT_METHOD_LIST_FAILURE: "GET_PAYMENT_METHOD_LIST_FAILURE",



  GET_PKRD_PAYMENT_HISTORY_LIST_REQUEST: "GET_PKRD_PAYMENT_HISTORY_LIST_REQUEST",
  GET_PKRD_PAYMENT_HISTORY_LIST_SUCCESS: "GET_PKRD_PAYMENT_HISTORY_LIST_SUCCESS",
  GET_PKRD_PAYMENT_HISTORY_LIST_FAILURE: "GET_PKRD_PAYMENT_HISTORY_LIST_FAILURE",

 

  //update status
  UPDATE_PAYMENT_METHOD_STATUS_REQUEST: "GET_PAYMENT_METHOD_STATUS_REQUEST",
  UPDATE_PAYMENT_METHOD_STATUS_SUCCESS: "GET_PAYMENT_METHOD_STATUS_SUCCESS",
  UPDATE_PAYMENT_METHOD_STATUS_FAILURE: "GET_PAYMENT_METHOD_STATUS_FAILURE",

    //get country code list
    GET_COUNTRY_CODE_LIST_REQUEST: "GET_COUNTRY_CODE_LIST_REQUEST",
    GET_COUNTRY_CODE_LIST_SUCCESS: "GET_COUNTRY_CODE_LIST_SUCCESS",
    GET_COUNTRY_CODE_LIST_FAILURE: "GET_COUNTRY_CODE_LIST_FAILURE",
};
